import { useTranslation } from "react-i18next";

import { QUESTION_RESULT_STATUSES } from "models";

export type PossibleQuestionStatusOptions = QUESTION_RESULT_STATUSES.OKWithRemarks | QUESTION_RESULT_STATUSES.Advice | QUESTION_RESULT_STATUSES.Necessary;
export type QuestionStatusOptions = [QUESTION_RESULT_STATUSES.OKWithRemarks, QUESTION_RESULT_STATUSES.Advice, QUESTION_RESULT_STATUSES.Necessary];

export const useQuestionResultStatusOptions = () => {
  const { t } = useTranslation();

  const questionResultStatusOptions = [
    { key: "all", value: "all", text: t("v8_all", "All"), icon: null, iconColor: "" },
    {
      key: QUESTION_RESULT_STATUSES.OKWithRemarks,
      value: QUESTION_RESULT_STATUSES.OKWithRemarks,
      text: t("v8_ok", "Ok"),
      icon: "file",
      iconColor: "#21BA45"
    },
    {
      key: QUESTION_RESULT_STATUSES.Advice,
      value: QUESTION_RESULT_STATUSES.Advice,
      text: t("v8_advice", "Advice"),
      icon: "triangle exclamation",
      iconColor: "#FFBA39"
    },
    {
      key: QUESTION_RESULT_STATUSES.Necessary,
      value: QUESTION_RESULT_STATUSES.Necessary,
      text: t("v8_necessary", "Necessary"),
      icon: "circle exclamation",
      iconColor: "#FF0202"
    }
  ];

  return { questionResultStatusOptions };
};
